import { memo } from 'react';

import useTranslation from '@Queries/useTranslation';
import Section from '../Section';
import Info from '../Info';
import Paragraphs from '../Paragraphs';

import type { FC, HTMLAttributes } from 'react';

export interface ExchangeAndRefundProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  conditions: string[];
  refund: string[];
  notice: string;
}

const ExchangeAndRefund: FC<ExchangeAndRefundProps> = (props) => {
  const { conditions, refund, notice, ...restProps } = props;
  const { t } = useTranslation();

  return (
    <Section {...restProps} title={t('refund')}>
      <Paragraphs>{conditions}</Paragraphs>

      <Info content={notice} />

      <Paragraphs>{refund}</Paragraphs>
    </Section>
  );
};

export default memo(ExchangeAndRefund);
